module.exports = __webpack_public_path__ + "img/square-caret-left.c6dc222d.svg";